import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Space, Switch, Tag } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { cmsLanguageName, supportedLanguages } from "../../helpers/language.js";
import { getTimeAgo } from "../../utilities/intl.js";
import { generateRouteUrl } from "../routes.js";

export const TemplateListColumns = (fetcher) => [
  {
    title: "Edit",
    key: "edit",
    render: (_, record) =>
      record.multilingual ? (
        <Dropdown
          menu={{
            items: supportedLanguages.map((language) => ({
              key: language,
              label: (
                <Link
                  key={language}
                  to={generateRouteUrl("EmailTemplateDetails", {
                    id: record.id,
                    language,
                  })}
                >
                  {cmsLanguageName(language)}
                </Link>
              ),
            })),
          }}
        >
          <Button size="small" type="primary" icon={<DownOutlined />}>
            Edit
          </Button>
        </Dropdown>
      ) : (
        <Link
          to={generateRouteUrl("EmailTemplateDetails", {
            id: record.id,
            language: "default",
          })}
        >
          <Button size="small" type="primary">
            Edit
          </Button>
        </Link>
      ),
  },
  {
    title: "History",
    dataIndex: "id",
    render: (id) => (
      <Link
        to={generateRouteUrl("EmailHistory", {
          id,
        })}
      >
        <Button>History</Button>
      </Link>
    ),
  },
  {
    title: "Status",
    dataIndex: "active",
    render: (active) => (active ? "Active" : "Not Active"),
  },
  {
    title: "Multilingual",
    dataIndex: "multilingual",
    // render: multilingual => multilingual ? 'Yes' : 'No'
    render: (multilingual, record) => (
      <Switch
        checked={!!multilingual}
        onChange={(checked) => {
          fetcher.submit(
            {
              id: record.id,
              action: "multilingual",
            },
            {
              replace: true,
              method: checked ? "POST" : "DELETE",
              encType: "application/json",
            },
          );
        }}
      />
    ),
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Scenario",
    dataIndex: "description",
    ellipsis: true,
  },
  {
    title: "Labels",
    dataIndex: "labels",
    render: (labels) => (
      <Space size={4} wrap>
        {(labels || []).map((label) => (
          <Tag
            key={label.id}
            color={label.color}
            style={{ borderRadius: 5, margin: 0, padding: "3px 8px", lineHeight: 1 }}
          >
            {label.name}
          </Tag>
        ))}
      </Space>
    ),
  },
  {
    title: "Last Updated",
    dataIndex: "updatedAt",
    render: getTimeAgo,
  },
  {
    title: "Updated By",
    dataIndex: ["user", "name"],
  },
];
